import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import Code from './error_codes';

//为了兼容远端数据字典自动调用

// let API_URL = 'http://www.ywbjchina.com/api';
let API_URL = '/'
let CancelToken = axios.CancelToken;

Vue.prototype.$CancelAjaxRequest = function() {};
Vue.prototype.$IsCancel = axios.isCancel;

const service = axios.create({
    baseURL: API_URL + '/',
    timeout: 60000,
    withCredentials: true,
});
service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
window.axios = service;

service.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        let res = response.data;
        if (!res) {
            res = {
                returnCode: Code.REMOTE_FAIL_CODE,
                returnMessage: '网络错误',
            };
        }
        if (res.returnCode != Code.SUCCESS_CODE) {
            // switch (res.returnCode) {
            //     case Code.BIZ_VALIDATE_FAIL_CODE:
            //     case Code.PARAM_FORMAT_WRONG_CODE:
            //     case Code.REQUIRE_PARAM_EMPTY_CODE:
            //     case Code.COMMON_BIZ_ERROR_CODE:
            //         Vue.prototype.$message.error(res.returnMessage);
            //         break;
            //     case Code.SUCCESS_BUT_CODE:
            //         Vue.prototype.$message.error('操作成功，但需被审核后生效');
            //         //Router.push({name: 'dashboard'})
            //         break;
            //     case Code.ACCESS_DENIED_CODE:
            //         Vue.prototype.$message.error('无操作权限');
            //         //Router.push({name: 'dashboard'})
            //         break;
            //     case Code.REQUIRED_AUTH_CODE:
            //         Vue.prototype.$message({
            //             message: '用户未登录',
            //             type: 'error',
            //             duration: 1000,
            //             onClose: () => {
            //                 //Router.push({ name: 'login' });
            //             },
            //         });
            //         break;
            //     default:
            //         if (res.returnMessage) {
            //             Vue.prototype.$message.error('无操作权限');
            //         }
            //         break;
            // }
            return Promise.reject(res);
        }
        return res;
    },
    (error) => {
        // if (!axios.isCancel(error)) {
        //     let res = {
        //         returnCode: -1,
        //         returnMessage: error.message ? error.message : '未知错误',
        //     };
        //     Vue.prototype.$message.error(res.message);
        //     return Promise.reject(res);
        // }
        return Promise.reject(error);
    }
);

export default service;
export function post(url, data, params, headers) {
    if (!params) {
        params = {};
    }
    params._t = new Date().getTime();
    let config = {
        method: 'post',
        url: url,
        params,
    };
    if (data) {
        if (headers && headers['Content-Type'] == 'multipart/form-data') {
            config.data = data;
        } else {
            config.data = qs.stringify(data, { indices: false });
        }
    }
    if (headers) {
        config.headers = headers;
    }

    config.cancelToken = new CancelToken(function(cancel) {
        Vue.prototype.$CancelAjaxRequest = function() {
            cancel();
        };
    });

    return service(config);
}

export function get(url, params, headers) {
    if (!params) {
        params = {};
    }
    params._t = new Date().getTime();
    let config = {
        method: 'get',
        url: url,
        params,
    };
    if (headers) {
        config.headers = headers;
    }

    config.cancelToken = new CancelToken(function(cancel) {
        Vue.prototype.$CancelAjaxRequest = function() {
            cancel();
        };
    });

    return service(config);
}





// WEBPACK FOOTER //
// ./src/utils/fetch.js